import {ActionTree, MutationTree} from 'vuex'
import {RootState} from '@/store/types'
import router from "@/router";

export interface State {
  loading: boolean,
  items: any[],
  platform: string,
}

const defaultState: State = {
  loading: false,
  items: [],
  platform: ''
}

const getters = {
  loading: (state: State) => state.loading,
  items: (state: State) => state.items,
  platform: (state: State) => state.platform
}

const mutations: MutationTree<State> = {
  setLoading(state: State, payload: boolean) {
    state.loading = payload
  },
  items(state: State, payload) {
    state.items = payload
  },
  setPlatform(state: State, payload) {
    state.platform = payload
  },
}


const actions: ActionTree<State, RootState> = {
  addItemsFromStorage({ commit, state }, { val }) {
    if (!state.items.length) {
      state.items.push(val)
      localStorage.items = JSON.stringify(state.items)
      return
    }
    const arr = JSON.parse(JSON.stringify(state.items))
    const itemIdx = arr.findIndex((el: any) => el.path === val.path && el.obj.type === val.obj.type)
    if (itemIdx !== -1) {
      state.items[itemIdx] = { ...val }
      localStorage.items = JSON.stringify(state.items)
    } else {
      state.items.push(val)
      localStorage.items = JSON.stringify(state.items)
    }
  },
  setError() {
    router.push({ name: 'Error'})
  },
  getMobileOperatingSystem({ commit, state }) {
    let userAgent = navigator.userAgent

    if (/android/i.test(userAgent)) {
      commit('setPlatform', "android")
    }

    if (/iPad|iPhone|iPod/.test(userAgent)) {
      commit('setPlatform', "apple")
    }
  }
}


export default {
  namespaced: true,
  state: defaultState,
  getters,
  mutations,
  actions,
};
